import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/http';
import type { Locale } from '@/lib/localized-paths';

export interface FooterChild {
  id: number;
  title: string;
  url: string;
  order: number;
}

export interface FooterItem {
  id: number;
  title: string;
  url: string;
  order: number;
  children?: FooterChild[];
}

export interface FooterResponse {
  success: boolean;
  data: FooterItem[];
}

export function useFooter(lang: Locale) {
  return useQuery<FooterResponse>({
    queryKey: ['footer', lang],
    queryFn: async () => {
      const res = await http.get(`/api/footer?lang=${lang}`);
      return res.data;
    },
  });
}
